<div class="container-fluid">

  <div class="card gutter-t gutter-b">
    <div class="card-header">
      <div class="d-flex">
        <h1>
          {{'common.service_levels'|translate}} 
        </h1>
        <!-- <button class="btn btn-primary ml-auto">{{'common.add_new'|translate|uppercase}}</button> -->
      </div>
    </div>
    <div class="card-body" *ngIf="(service.levels$ | async)?.length > 0">

      <table class="table">
        <thead>
          <tr>
            <th scope="col">{{'common.name'|translate|titlecase}}</th>
            <th scope="col">{{'common.description'|translate|titlecase}}</th>
            <th scope="col">{{'common.self_service'|translate|titlecase}}</th>
            <th scope="col">{{'common.service_products'|translate|titlecase}}</th>
            <th scope="col"><!-- actions --></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let level of service.levels$ | async">
            <td>
              {{level.name}}
              <!-- <input type="text" class="form-control" value="blah"/>form-control-lg -->
            </td>
            <td>
              {{level.description}}
            </td>
            <td>
              {{'true_yes.'+level.is_self_service|translate}}
            </td>
            <td>
              2
            </td>
            <td>
              <span class="btn btn-primary p-1 m-1 mr-2"><i-bs name="pencil" class="p-0 m-0"></i-bs></span>
              <span class="btn btn-outline-danger p-1 m-1 mr-2"><i-bs name="x" class="p-0 m-0"></i-bs></span>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>

</div>